import { render, staticRenderFns } from "./PatientSurgeryAuditLog.vue?vue&type=template&id=f0938fa6&scoped=true"
import script from "./PatientSurgeryAuditLog.vue?vue&type=script&lang=js"
export * from "./PatientSurgeryAuditLog.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgeryAuditLog.vue?vue&type=style&index=0&id=f0938fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0938fa6",
  null
  
)

export default component.exports